import ThemeBtn from '@/components/antd-comp/theme-btn'
import InputAntDef from '@/components/input/InputAntDef'
import { useTranslation } from 'react-i18next'
import TabsDropComponent from '../../../components/TabsDropComponent/index'
import '../css/styles.css'

/* 提示词 table头部筛选 */
export default function CallTableHead({ num, SearchList, diaEdit, setSearchName, seleCarFun }) {
  const { t } = useTranslation()
  return (
    <div className="flexRowStart" style={{ width: '100%' }}>
      <TabsDropComponent
        backColor={'#ffffff'}
        list={SearchList}
        num={num}
        tabsDropFun={seleCarFun}
        style={{ marginRight: '16px' }}
      ></TabsDropComponent>
      <div className="flexRowJustBet flex" style={{ flex: '1' }}>
        <InputAntDef
          searchFun={e => {
            setSearchName(encodeURIComponent(e.target.value))
          }}
          placeholder={t('call.searchName')}
        ></InputAntDef>
        <ThemeBtn className="themeBtn_callwordPage lenovo-font-600 h-[36px] w-[92px]" onClick={() => diaEdit()}>
          {t('create')}
        </ThemeBtn>
      </div>
    </div>
  )
}
